import HTTP from '@/plugins/axios';
import type { IAiExtractJobFiltersResponse, IAiExtractJobGroupFiltersResponse } from '@/types/aiTool';

export const extractJobFilters = async(params: { text: string, sid?: string }) => {
  const { sid, ...body } = params;
  // v=2: job_types as { type: true | false | null } with all job types (ticket 19788)
  const response = await HTTP.post('/ai_tool/extract_job_filters', body, { params: sid != null ? { sid, v: 2 } : { v: 2 } });
  return response.data as IAiExtractJobFiltersResponse;
};

export const extractJobGroupFilters = async(params: { text: string, sid: string }) => {
  const { sid, ...body } = params;
  const response = await HTTP.post('/ai_tool/extract_job_group_filters', body, { params: { sid } });
  return response.data as IAiExtractJobGroupFiltersResponse;
};
